module.exports = __webpack_public_path__ + "img/Nyromantikk_Tanker_i_tida_Kinck.33053371.jpg";